import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { AuthState } from '@/types/auth.types';

export const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      user: null,
      tokens: null,
      isAuthenticated: false,

      setAuth: (user, tokens) => {
        set({user, tokens, isAuthenticated: true});
      },

      clearAuth: () => {
        set({user: null, tokens: null, isAuthenticated: false});
      },

      updateTokens: (tokens) => {
          set({tokens});
      }
    }),
    {
      name: 'auth-storage',
    }
  )
);